var _permissionCache = null;
var _userCache = null;

/**非空校验 */
export function nonNullCheck(val) {
  if (val == null || val == "" || val == undefined) {
    return "--";
  } else {
    return val;
  }
}
// 获取 user
export function getUser() {
  if (_userCache) return _userCache;

  try {
    _userCache = JSON.parse(localStorage.getItem("user")) || {};
  } catch (e) {
    _userCache = {};
  }

  return _userCache;
}
/**
 * 判断当前用户是否为操作人
 * @param {String|Number} operatorId 当前数据里的操作人ID
 * @returns {Boolean}
 */
export function isCurrentUser(operatorId) {
  const currentUserId = getRoleId(); // 你项目里的用户ID位置
  // 统一转字符串，避免 1 和 "1" 比较失败
  return operatorId == currentUserId;
}
export function getClientId() {
  var user = getUser();
  return user.clientId;
}
// 获取 roleId
export function getRoleId() {
  var user = getUser();
  return user.roleId || null;
}
// 获取 Id
export function getId() {
  var user = getUser();
  return user.id || null;
}
// 获取权限列表
export function getPermissions() {
  if (_permissionCache) return _permissionCache;
  try {
    _permissionCache = JSON.parse(localStorage.getItem("permissions")) || [];
  } catch (e) {
    _permissionCache = [];
  }

  return _permissionCache;
}

// 清缓存（登录 / 退出时用）
export function clearPermissionCache() {
  _permissionCache = null;
  _userCache = null;
}

// 核心方法：判断权限
export function hasPermission(value, mode) {
  var permissions = getPermissions();

  if (!value) return false;

  // 单个权限
  if (typeof value === "string") {
    return permissions.includes(value);
  }

  // 多个权限
  if (Array.isArray(value)) {
    if (mode === "all") {
      return value.every(function (item) {
        return permissions.includes(item);
      });
    } else {
      return value.some(function (item) {
        return permissions.includes(item);
      });
    }
  }

  return false;
}
